import { Etablissement } from '@/../lib/mce-ihm-shared/src/interfaces/user';

function getCurrentEtablissement(): Etablissement | undefined {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	return (window as any)?.mce?.authorization?.currentEtablissement$?.value;
}

export function getCurrentSiret(): string | undefined {
	return getCurrentEtablissement()?.siret;
}

export function buildUrlWithSiret(
	baseUrl: string,
	params: Record<string, string | null | undefined> = {}
): string {
	const urlParams = new URLSearchParams();

	Object.entries(params).forEach(([key, value]) => {
		if (value) {
			urlParams.append(key, value);
		}
	});

	const siret = getCurrentSiret();
	if (siret && !params['siret']) {
		urlParams.append('siret', siret);
	}

	const queryString = urlParams.toString();
	return queryString ? `${baseUrl}?${queryString}` : baseUrl;
}
